'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';

const DataDogRUM = () => {
  useEffect(() => {
    if (
      process.env.DATADOG_APPLICATION_ID &&
      process.env.DATADOG_CLIENT_TOKEN
    ) {
      datadogRum.init({
        applicationId: process.env.DATADOG_APPLICATION_ID,
        clientToken: process.env.DATADOG_CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'landing-page-client-next',
        env: process.env.DEPLOYABLE_ENV,
        version: process.env.NEXT_PUBLIC_APP_VERSION,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
      });
    }
  }, []);

  return null;
};

export { datadogRum }; // Export the datadogRum instance
export default DataDogRUM;
